import React from 'react';
import { useTranslation } from 'react-i18next';

const LegalPage: React.FC = () => {
  const { t } = useTranslation();

  const sections = [
    { key: 'companyRegistration', num: '1' },
    { key: 'regulatoryCompliance', num: '2' },
    { key: 'dataProtection', num: '3' },
    { key: 'liability', num: '4' },
    { key: 'intellectualProperty', num: '5' },
    { key: 'contact', num: '6' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden p-8">
        <div className="text-center mb-10 border-b pb-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">{t('legalPage.title')}</h1>
          <p className="text-lg text-gray-600">{t('legalPage.subtitle')}</p>
        </div>

        <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
          {sections.map(({ key, num }) => (
            <section key={key}>
              <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4 flex items-center">
                <span className="mr-3 bg-gray-200 text-gray-700 rounded-full w-8 h-8 flex items-center justify-center text-sm">{num}</span>
                {t(`legalPage.${key}.title`)}
              </h2>
              <p className="mb-4">{t(`legalPage.${key}.content`)}</p>
            </section>
          ))}
        </div>

        <div className="mt-12 text-center text-gray-500 text-sm">
          <p>{t('common.licenseInfo')}</p>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
